const QueryTypes = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
};

export default QueryTypes;
